import { useEffect, useState } from 'react';

import { ButtonSpinnerDarkIcon } from '@svgs';

export const DeleteLocation = ({ locationData, deleteLocation }) => {
  // disassociate confirmation
  const [showConfirmation, setShowConfirmation] = useState(false);

  // shared isPending
  const isPending = deleteLocation.isPending;

  useEffect(() => {
    // reset the confirmation state when the location changes
    setShowConfirmation(false);
  }, [locationData]);

  const onDeleteLocation = async () => {
    deleteLocation.mutate(locationData.id);
  };

  return (
    <div className="sb-message sb-flex sb-message-delete">
      <div className="sb-flex sb-message-delete-inner">
        <span className="sb-message-icon"></span>
        <div className="sb-message-content">
          <p className="sb-message-title">Delete this location</p>
          <p className="sb-message-msg">
            This location will be deleted completely and removed from any
            websites that have it associated with them
          </p>
        </div>
      </div>
      {(!showConfirmation || isPending) && (
        <button
          type="button"
          className="sb-btn sb-btn-delete"
          onClick={() => setShowConfirmation(true)}
        >
          {isPending ? `Deleting...` : 'Delete'}
          {isPending && <ButtonSpinnerDarkIcon />}
        </button>
      )}
      {showConfirmation && !isPending && (
        <div>
          <button
            type="button"
            className="sb-btn sb-btn-delete-confirm"
            onClick={onDeleteLocation}
          >
            Confirm deletion
          </button>
          <button
            type="button"
            className="sb-btn sb-btn-delete"
            onClick={() => setShowConfirmation(false)}
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};
